import React from 'react'
import { View, ViewProps } from 'react-native'
import tw from 'tailwind-rn'

type Props = ViewProps & {
  children?: React.ReactNode
}

const HGView = (props: Props) => {
  const { children, style } = props

  return (
    <View style={tw('flex-1 items-center')}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <View {...props} style={[tw('flex-1 w-full max-w-2xl'), style]}>
        {children}
      </View>
    </View>
  )
}

export default HGView
